export default {"src":"/_next/static/media/special-online-prices.799b8e85.svg","height":512,"width":512};